import { render, staticRenderFns } from "./AdminProdStatus.vue?vue&type=template&id=97fc2e96&scoped=true&"
import script from "./AdminProdStatus.vue?vue&type=script&lang=js&"
export * from "./AdminProdStatus.vue?vue&type=script&lang=js&"
import style0 from "./AdminProdStatus.vue?vue&type=style&index=0&id=97fc2e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fc2e96",
  null
  
)

export default component.exports